import React from 'react';
import {
  SUPPORT_EMAIL,
  SUPPORT_EMAIL_URL,
  SUPPORT_WHATSAPP_NUMBER,
  SUPPORT_WHATSAPP_URL,
  SUPPORT_RESPONSE_TIME,
} from '../utils/supportContact';

export default function SupportContact() {
  return (
    <section aria-label="Contact Wedlinx support" className="mt-5 space-y-2 text-sm text-secondary-80">
      <h3 className="font-semibold text-secondary">Need help with Wedlinx?</h3>
      <p>
        Email{' '}
        <a className="break-all underline" href={SUPPORT_EMAIL_URL}>{SUPPORT_EMAIL}</a>
      </p>
      <p>
        WhatsApp{' '}
        <a className="inline-flex min-h-11 items-center underline" href={SUPPORT_WHATSAPP_URL}>{SUPPORT_WHATSAPP_NUMBER}</a>
      </p>
      <p className="text-xs text-secondary-70">{SUPPORT_RESPONSE_TIME}</p>
    </section>
  );
}
